const Privacy = () => {
  return <p>Privacy Policy</p>
}

export default Privacy
